import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { BookingWizardScreen } from "../components/bookings/BookingWizardScreen";

const searchSchema = z.object({
  treatment_id: z.string().uuid().optional(),
  therapist_user_id: z.number().int().optional(),
  starts_at: z.string().optional(),
  client_id: z.string().uuid().optional(),
});

export const Route = createFileRoute("/_auth/bookings/new")({
  staticData: {
    titleKey: "nav.bookings",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 4,
  },
  validateSearch: searchSchema,
  component: BookingNewRoute,
});

function BookingNewRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  return (
    <BookingWizardScreen
      treatmentIdFromUrl={search.treatment_id}
      therapistIdFromUrl={search.therapist_user_id}
      startsAtFromUrl={search.starts_at}
      clientIdFromUrl={search.client_id}
      onClose={() => navigate({ to: "/bookings" })}
      onCreated={(id) => navigate({ to: "/bookings", search: { selected: id } as never })}
    />
  );
}
